export default "__VITE_ASSET__DPgAcuuX__"